/**
 * Changes made:
 * - 2025-09-28: Created Partners component with "NASI PARTNERZY" heading and partner logos
 */

import carvertical from "@/assets/carvertical-logo.png";
import autobaza from "@/assets/autobaza-logo.png";

export const Partners = () => {
  return (
    <div className="w-full -mt-8 md:mt-0 pt-0 pb-2 px-4 md:px-8 flex flex-row md:flex-wrap items-center justify-center gap-4 sm:gap-6 md:gap-16">
      <img 
        src={carvertical} 
        alt="Carvertical" 
        className="h-24 sm:h-24 md:h-32 object-contain flex-shrink-0"
      />
      <h2 className="text-sm sm:text-lg md:text-xl font-semibold font-['Kanit'] text-center" style={{ color: '#454545' }}>
        NASI PARTNERZY
      </h2>
      <img 
        src={autobaza} 
        alt="Autobaza" 
        className="h-24 sm:h-24 md:h-32 object-contain flex-shrink-0"
      />
    </div>
  );
};